import { useEffect, useRef } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { UNCONFIRMED_CLIENT_ROLE } from '@/features/auth/hooks/use-is-unconfirmed-client';
import { useWhoami } from '@/features/auth/hooks/use-whoami-query';

import { useGetDocumentConsentStatus } from './use-get-document-consent-status';
import { useLogConsent } from './use-log-consent';

export function useSyncCaptchaConsent() {
  const queryClient = useQueryClient();
  const { data: whoamiData } = useWhoami({ params: {} });
  const isSyncingRef = useRef(false);

  const isAuthorized =
    whoamiData !== undefined &&
    whoamiData.auth.userId !== null &&
    !whoamiData.auth.roles.includes(UNCONFIRMED_CLIENT_ROLE);

  const { data: consentStatus } = useGetDocumentConsentStatus({
    params: { documentKey: 'captcha_consent' },
    enabled: isAuthorized,
  });

  const { mutate: logConsent } = useLogConsent({
    onSuccess: () => {
      isSyncingRef.current = false;
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes(useGetDocumentConsentStatus.method),
      });
    },
    onError: () => {
      isSyncingRef.current = false;
    },
  });

  useEffect(() => {
    if (!isAuthorized || !consentStatus || isSyncingRef.current) {
      return;
    }

    if (consentStatus.hasConsent === false) {
      isSyncingRef.current = true;
      logConsent({
        action: 'grant',
        formType: 'login',
        signedDocuments: ['captcha_consent'],
        checkboxesState: {
          captcha_consent: true,
        },
      });
    }
  }, [isAuthorized, consentStatus, logConsent]);
}
